import { useLeaflet } from "react-leaflet";
import { useEffect } from "react";
import "leaflet.locatecontrol";
import { connect } from "react-redux";
import {selectDataList} from '../redux'
import axios from 'axios'
import * as WMS from "leaflet.wms";
// import I18nextBrowserLanguageDetector from "i18next-browser-languagedetector";

var XMLParser = require('react-xml-parser');

const addLayer = (map,serviceUrl,nome,zIndex,opacity) => {
    
    
    // const version = service_config.serviceOnScreen.services[0].version
    const options = {
        "version": "1.1.0",
        "format": "image/png",
        "transparent": "true", 
        "info_format": "application/json",
        "opacity": opacity,
        "zIndex": zIndex,
        fetchOptions: {headers: window.tp_headers}
        // "cql_filter": "comune LIKE 'S%'"
    }
    
    
    // Add WMS source/layers
    const source = WMS.source(
        serviceUrl,
        options
    );
    

   
        source.getLayer(nome).addTo(map)
        

    // try {       
    //  L.tileLayer.wms(serviceUrl, {
    //     layers: nome,zIndex: zIndex,transparent: "true", format: "image/png",opacity: opacity,info_format:"application/json",
    // }).addTo(map);
           
    // } catch (error) {
    
    // }


}

const removeLayer = (map,nome) => {
   
map.eachLayer(element => {
    
  if ( element._name === nome) {
    try { 
      map.removeLayer(element)

  }
  catch(e) {
      
  }
  }
  
  
}); 

}

const setOpacity = (map,nome,value) => {

    map.eachLayer(element => {
        
      if ( element._name === nome) {
        try {
        
           element.setOpacity(value)
      }
      catch(e) {
          
      }
      }
      
      
    }); 
    
    }

const Toc = (props) => {
    const { map } = useLeaflet();
    const checkBox = props.tocCheckBox.checkbox
    
    const nodesOpacity = props.tocSlider
    var dataList = props.dataList.data
    
    const zoomTo = props.zoomTo

    const modificaLayer = (url,nome,stato,opacity,zIndex) => {
        if (stato === true){
            
            addLayer(map,url,nome,zIndex,opacity)
        }else{
            removeLayer(map,nome)
        }
         
    }

    // Funzione per lo zoom su di un determinato layer   
    const effettuaZoom = (url,name) =>{
        
        let len = url.lastIndexOf('/') + 1
        var output = url.substring(0, len) + `${name}/` + url.substring(len);
        axios.get(output + "&request=GetCapabilities",{headers: window.tp_headers})
        .then(response => {
            const paths = response.data
            var json = new XMLParser().parseFromString(paths);
            
            json.children.map(x => {
                
                 if (x.name === "Capability"){
                    x.children.map(y=>{
                        if (y.name === "Layer"){
                            y.children.map(z=>{
                                if (z.name === "--All"){
                                    z.children.map(t=>{
                                        if (t.name === "BoundingBox"){
                                            const lon = [t.attributes.maxy, t.attributes.maxx] 
                                            const lng = [t.attributes.miny, t.attributes.minx]
                                           
                                            
                                            map.fitBounds([lon,lng],{zoom:13})
                                        }
                                        return null
                                    })
                                }
                                return null
                            })
                        }
                        return null
                    })
                 }
                 return null
            })

        })
        .catch( error => {

        })
    }


    useEffect(()=>{
        if( zoomTo.nodesTo.serviceUrl !== undefined){
            
            effettuaZoom(zoomTo.nodesTo.serviceUrl,zoomTo.nodesTo.name)
        }
    },[zoomTo])

        //useEffect per gestire l attivazione del layer in base alla checkbox cliccata
       useEffect(()=>{
        try {
            if (checkBox.element !== undefined){
                dataList.children.map(x => {
                    if (x === checkBox) {
                        x.visible = !x.visible
                        x.children.map(y =>{
                            y.visible = x.visible
                            modificaLayer(y.serviceUrl,y.name,x.visible,y.opacity,y.id)
                            return null
                        })
                    }
                    return null
                })
            }  else {
                dataList.children.map(x => {
                    x.children.map(y =>{
                        if (y===checkBox){
                            y.visible=!y.visible
                            modificaLayer(y.serviceUrl,y.name,y.visible,y.opacity,y.id)
                        }
                        return null
                    })
                    return null
                })
            }  
        } catch (error) {
            
        }
        props.changeDataList(dataList)

    }, [props.tocCheckBox ])   
    useEffect(()=>{
        const nodesName = nodesOpacity.nodes.name
        const nodesOpacityValue = nodesOpacity.nodes.opacity
    setOpacity(map,nodesName,nodesOpacityValue)
    },[nodesOpacity])


    useEffect(()=>{
 
        dataList.children.map(x=>{
            x.children.map(y=>{
                 if (y.visible === true){
                    modificaLayer(y.serviceUrl,y.name,false,y.opacity,y.id)
                    modificaLayer(y.serviceUrl,y.name,true,y.opacity,y.id)
            }
            return null
            })
            return null
        }) 


    },[props.dataList])


    return null;
};


const mapStateToProps = state => {
    return {
        tocCheckBox: state.tocCheckBox,
        dataList: state.dataList,
        tocSlider: state.tocSlider,
        zoomTo: state.zoomTo
    }
  }
  const mapDispatchToProps = dispatch => {
    return {
      changeDataList: (dataList) => dispatch(selectDataList(dataList))
    }
}
export default connect(mapStateToProps,mapDispatchToProps) (Toc);